import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import green from "@material-ui/core/colors/green";
import { getLocationGroup,getLogisticPoint } from "../../reducers/map/api";
import {
  apiPointListRequest,
  apiPointListReset
} from "../../reducers/api";
import { selectLocationGroup } from "../../reducers/ui/selectList";
import { connect } from "react-redux";

import Configs from "../../config/config";
const env = process.env.NODE_ENV;

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  formControl: {
    margin: theme.spacing.unit
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  button: {
    margin: theme.spacing.unit
  },
  padding5px: {
    display: "flex",
    flexWrap: "wrap",
    padding: "5px",
    margin: "10px"
  },
  cssGreen: {
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700]
    }
  },
  titlePanel: {
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[500])
  },
  selectStyles: {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      minWidth  :200,
      "& input": {
        font: "inherit"
      }
    })
  }
});

class LocationGroupSelect extends Component {
  constructor(props){
    super(props);
    this.state = {
      logistic: "",
      logisticText: "",
      location: "",
      locationText: "",
      locationDetail: "",
      name: "hai",
      mode: "",
      actionsLocationPointGroup: false,
      actionsLocationGroup: false,
    }
  };
  handleChange = event => {
    let valueSelect = JSON.parse(event.target.value);
    let payload = { value : event.target.value , text:valueSelect.name};
    this.props.selectLocationGroup(payload);
    
    //Data for create Marker Group

    
    this.props.GET_LOGISTIC_POINTS({
      url:Configs[env].BACKEND_HOST + "/locationCond",
      filter: {
        logisticsPointGroup: valueSelect.logisticsPointGroup,
        locationGroupId: valueSelect.id,
      }
    });
  };
  renderMenuItem() {
    if(this.props.location_group !== undefined){
      var menuItem = this.props.location_group;
      return menuItem.map(function(data, index) {
        return (
          <MenuItem key={index} value={JSON.stringify(data)}>
            {data.name}
          </MenuItem>
        );
      });
    }
    else 
      return null;
  }
  render() {
    return (
        <FormControl>
            <InputLabel shrink htmlFor="location-required">
              {this.props.label}
            </InputLabel>
            <Select
              testing="select-location-group"
              value={this.props.locationGroup.value}
              onChange={this.handleChange}
              styles={styles.selectStyles}
              name="location"
              placeholder="Search Location Group"
              inputProps={{
                  id: "location-required"
              }}
            >
            {this.renderMenuItem()}
            </Select>
        </FormControl>
    );
  }
}
const mapStateToProps = function(state) {
  return {
    locationGroupList: state.api.resultGroupList,
    locationGroup: state.selection.locationGroup,
    location_group: state.map.location_group,//Kong
  };
};
const mapActionsToProps = {
  selectLocationGroup,
  apiPointListRequest,
  apiPointListReset,
  GET_LOCATION_GROUP: getLocationGroup,//Kong
  GET_LOGISTIC_POINTS : getLogisticPoint,//Kong
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(LocationGroupSelect));
